// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page_sigle[data-v-39b1453f]{width:100%;height:100%;position:relative}.tip[data-v-39b1453f]{position:absolute;font-size:.125rem;top:50%;left:50%;transform:translate(-50%,-50%);color:#333;text-align:center}.tip .imgtip[data-v-39b1453f]{width:3.55556rem;height:3.55556rem}", ""]);
// Exports
module.exports = exports;
